import styled, { css } from "styled-components";
import { CssGrid } from "styles/helpers/layout";

import type { ThemeProps } from "models/styles/theme";

import type { NotificationPosition, NotificationType } from "./Notification.model";

interface Props extends ThemeProps {
  $variant?: NotificationType;
  $position?: NotificationPosition;
}

export const StyledNotification = styled(CssGrid)<Props>`
  width: 30rem;
  padding: 1.25rem 1.5rem;

  /* -- Color customization based on notification type -- */
  ${(props: Props) => {
    switch (props.$variant) {
      case "warning":
        return css`
          background: ${(props: Props) => props.theme.palette.yellow._999};
          border: solid 1px ${(props: Props) => props.theme.palette.yellow._600};

          > i {
            color: ${(props: Props) => props.theme.palette.yellow.brand};
          }
        `;
      case "error":
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.error._999};
          border: solid 1px ${(props: Props) => props.theme.palette.feedback.error._600};

          > i {
            color: ${(props: Props) => props.theme.palette.feedback.error.brand};
          }
        `;
      default:
        return css`
          background: ${(props: Props) => props.theme.palette.feedback.info._999};
          border: solid 1px ${(props: Props) => props.theme.palette.feedback.info._600};

          > i {
            color: ${(props: Props) => props.theme.palette.feedback.info.brand};
          }
        `;
    }
  }}

  /* -- Notification positioning -- */
  ${(props: Props) => {
    switch (props.$position) {
      case "bottomRight":
        return css`
          position: fixed;
          bottom: 4rem;
          right: 3rem;
        `;
      case "topRight":
        return css`
          position: fixed;
          top: 3rem;
          right: 3rem;
        `;
      default:
        return css``;
    }
  }}
`;
